/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchAvailabilityInfo } from './';
import {
    SourcingSearchAvailabilityInfoFromJSON,
    SourcingSearchAvailabilityInfoFromJSONTyped,
    SourcingSearchAvailabilityInfoToJSON,
} from './';
import type { SourcingSearchFreelancer } from './';
import {
    SourcingSearchFreelancerFromJSON,
    SourcingSearchFreelancerFromJSONTyped,
    SourcingSearchFreelancerToJSON,
} from './';
import type { SourcingSearchFreelancerType } from './';
import {
    SourcingSearchFreelancerTypeFromJSON,
    SourcingSearchFreelancerTypeFromJSONTyped,
    SourcingSearchFreelancerTypeToJSON,
} from './';
import type { SourcingSearchFreelancerVertical } from './';
import {
    SourcingSearchFreelancerVerticalFromJSON,
    SourcingSearchFreelancerVerticalFromJSONTyped,
    SourcingSearchFreelancerVerticalToJSON,
} from './';
import type { SourcingSearchMatchingHighlight } from './';
import {
    SourcingSearchMatchingHighlightFromJSON,
    SourcingSearchMatchingHighlightFromJSONTyped,
    SourcingSearchMatchingHighlightToJSON,
} from './';
import type { SourcingSearchMatchingSkill } from './';
import {
    SourcingSearchMatchingSkillFromJSON,
    SourcingSearchMatchingSkillFromJSONTyped,
    SourcingSearchMatchingSkillToJSON,
} from './';
import type { SourcingSearchPhoto } from './';
import {
    SourcingSearchPhotoFromJSON,
    SourcingSearchPhotoFromJSONTyped,
    SourcingSearchPhotoToJSON,
} from './';
import type { SourcingSearchResultOrigin } from './';
import {
    SourcingSearchResultOriginFromJSON,
    SourcingSearchResultOriginFromJSONTyped,
    SourcingSearchResultOriginToJSON,
} from './';
import type { SourcingSearchUnavailability } from './';
import {
    SourcingSearchUnavailabilityFromJSON,
    SourcingSearchUnavailabilityFromJSONTyped,
    SourcingSearchUnavailabilityToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchRegisteredFreelancer
 */
export interface SourcingSearchRegisteredFreelancer extends SourcingSearchFreelancer {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    identityId?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    headline: string;
    /**
     * 
     * @type {SourcingSearchFreelancerVertical}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    acceptedVertical?: SourcingSearchFreelancerVertical;
    /**
     * 
     * @type {SourcingSearchAvailabilityInfo}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    availabilityInfo: SourcingSearchAvailabilityInfo;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    dailyRateByCurrency: { [key: string]: number; };
    /**
     * 
     * @type {Date}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    lastConnection?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    keywords: Array<string>;
    /**
     * 
     * @type {Array<SourcingSearchMatchingSkill>}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    matchingSkills?: Array<SourcingSearchMatchingSkill>;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    skillsMatchingScore?: number;
    /**
     * 
     * @type {SourcingSearchResultOrigin}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    origin?: SourcingSearchResultOrigin;
    /**
     * 
     * @type {SourcingSearchUnavailability}
     * @memberof SourcingSearchRegisteredFreelancer
     */
    unavailability?: SourcingSearchUnavailability;
}

/**
 * Check if a given object implements the SourcingSearchRegisteredFreelancer interface.
 */
export function instanceOfSourcingSearchRegisteredFreelancer(value: object): value is SourcingSearchRegisteredFreelancer {
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    if (!('headline' in value) || value['headline'] === undefined) return false;
    if (!('availabilityInfo' in value) || value['availabilityInfo'] === undefined) return false;
    if (!('dailyRateByCurrency' in value) || value['dailyRateByCurrency'] === undefined) return false;
    if (!('keywords' in value) || value['keywords'] === undefined) return false;
    return true;
}

export function SourcingSearchRegisteredFreelancerFromJSON(json: any): SourcingSearchRegisteredFreelancer {
    return SourcingSearchRegisteredFreelancerFromJSONTyped(json, false);
}

export function SourcingSearchRegisteredFreelancerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchRegisteredFreelancer {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SourcingSearchFreelancerFromJSONTyped(json, ignoreDiscriminator),
        'profileId': json['profileId'],
        'accountId': json['accountId'],
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'fullName': json['fullName'],
        'location': json['location'] == null ? undefined : json['location'],
        'headline': json['headline'],
        'acceptedVertical': json['acceptedVertical'] == null ? undefined : SourcingSearchFreelancerVerticalFromJSON(json['acceptedVertical']),
        'availabilityInfo': SourcingSearchAvailabilityInfoFromJSON(json['availabilityInfo']),
        'dailyRateByCurrency': json['dailyRateByCurrency'],
        'lastConnection': json['lastConnection'] == null ? undefined : (new Date(json['lastConnection'])),
        'keywords': json['keywords'],
        'matchingSkills': json['matchingSkills'] == null ? undefined : ((json['matchingSkills'] as Array<any>).map(SourcingSearchMatchingSkillFromJSON)),
        'skillsMatchingScore': json['skillsMatchingScore'] == null ? undefined : json['skillsMatchingScore'],
        'origin': json['origin'] == null ? undefined : SourcingSearchResultOriginFromJSON(json['origin']),
        'unavailability': json['unavailability'] == null ? undefined : SourcingSearchUnavailabilityFromJSON(json['unavailability']),
    };
}

export function SourcingSearchRegisteredFreelancerToJSON(value?: SourcingSearchRegisteredFreelancer | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SourcingSearchFreelancerToJSON(value, true),
        'profileId': value['profileId'],
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'fullName': value['fullName'],
        'location': value['location'],
        'headline': value['headline'],
        'acceptedVertical': SourcingSearchFreelancerVerticalToJSON(value['acceptedVertical']),
        'availabilityInfo': SourcingSearchAvailabilityInfoToJSON(value['availabilityInfo']),
        'dailyRateByCurrency': value['dailyRateByCurrency'],
        'lastConnection': value['lastConnection'] == null ? undefined : ((value['lastConnection']).toISOString()),
        'keywords': value['keywords'],
        'matchingSkills': value['matchingSkills'] == null ? undefined : ((value['matchingSkills'] as Array<any>).map((v) => SourcingSearchMatchingSkillToJSON(v))),
        'skillsMatchingScore': value['skillsMatchingScore'],
        'origin': SourcingSearchResultOriginToJSON(value['origin']),
        'unavailability': SourcingSearchUnavailabilityToJSON(value['unavailability']),
    };
}

